import { OnInit, Component, ViewChild, Output, EventEmitter, Input, ChangeDetectorRef } from "@angular/core";
import { Subscription } from "rxjs";
import { ClaimsService } from "../../_services/common/claims.service";
import { TranslateService } from "@ngx-translate/core";
import { Claims } from "../../_models/common/claims";
import { AppGridComponent } from "../../shared/grid/grid-component/grid.component";
import { ColDef } from "ag-grid-community";
import { GridConfig } from "../../_models/common/grid/grid-config";
import { ExpenseCategoryInExpenseRequest, ExpenseCategoryRequest } from "src/app/_models/claimant/expense-category-request";
import { GetAndSaveItemBrandsReqResp, ItemBrand, SelectVendorBrandInputModel, SelectVendorBrandOutputModel } from "src/app/_models/vendor/vendor.model";
import { ApiRequest, IApiresponse } from "src/app/_models";
import { environment } from "src/environments/environment";
import { VendorService } from "src/app/_services/vendor/vendor.service";
import { AlertPanelModel } from "src/app/_models/common/alertPanelModel";

@Component({
    selector: "vendor-brand-mapping-panel",
    templateUrl: "./vendor-brand-mapping-panel.component.html",
    standalone: false
})

export class VendorBrandMappingPanelComponent implements OnInit {

    @ViewChild('vendorBrandGrid') gridComponent: AppGridComponent;
    @Input() inputData: SelectVendorBrandInputModel;
    @Output() closePanelEvent = new EventEmitter<boolean>();
    @Output() submitPanelEvent = new EventEmitter<any>();

    claimsSubscription: Subscription;
    userActionEventSubscription: Subscription;
    claims: Claims;
    gridColumnDefs: ColDef[];
    gridConfigItems: GridConfig;
    gridData:any[] = [];
    defaultSortColumn: string = 'brandName';
    defaultSortOrder: string = 'asc';

    hasFormChanges: boolean = false;
    expenseCategoryList: any[];
    expenseCategoryRequest: ExpenseCategoryRequest;
    expenseCategoryInExpenseRequest: ExpenseCategoryInExpenseRequest;
    checkedList = [];
    selectedIds:number[] = [];
    outputModel: SelectVendorBrandOutputModel = new SelectVendorBrandOutputModel();
    manageCategoryResponse: any;
    isAddVendorCategory: boolean = false;
    categoryFormModel: any = {};
      list: ItemBrand[] = [];
      alertPanelModel = new AlertPanelModel(
    false,
    "",
    [""],
    "",
    "",
    true,
    this.translate.instant("please_review_or_confirm")
  );
    constructor(
        private claimsService: ClaimsService,
        private translate: TranslateService,
        private cdr: ChangeDetectorRef,
        private vendorService: VendorService
    ) {
        this.claimsSubscription = this.claimsService.currentClaims.subscribe((claims) => {
            this.claims = claims;
        });
    }

    ngOnInit(): void {
        this.fnInitialiseGrid();
        this.selectedIds = this.inputData.assignedIdsList && this.inputData.assignedIdsList.length > 0 ? this.inputData.assignedIdsList.map(a => a.itemBrandId) : [];
        this.GetBrandList();
    }

 fnClosePanel() {
        if (this.hasFormChanges) {
            this.alertPanelModel = new AlertPanelModel(
        true,
        this.translate.instant("alert_info"),
        [this.translate.instant("business_purpose_discard_msg")],
        this.translate.instant("cancel"),
        this.translate.instant("label_confirm"),
        true,
        this.translate.instant("please_review_or_confirm")
      );
        }
        else {
            this.closePanelEvent.emit(true);
        }
    }

    fnInitialiseGrid() {
        this.fnCreateColumnDefs();
        this.fnGetGridConfigItems();
        setTimeout(() => {
            this.gridComponent.initializeGrid();
            this.cdr.detectChanges();
        }, 100);

    }

    fnCreateColumnDefs() {
        this.gridColumnDefs = [
            {
                headerName: this.translate.instant('brand'),
                field: 'brandName',
                resizable: true,
                sortable: true,
                suppressHeaderMenuButton: true,
                minWidth: 100
            },
        ]
      
    }

    fnGetGridConfigItems() {
        this.gridConfigItems = new GridConfig(
            false,
            true,
            this.defaultSortColumn,
            'itemBrandId',
            0,
            true,
            [],
            true,
            true,
            true,
            null,
            this.defaultSortOrder,
            40,
            this.translate.instant('no_data_availabe'),
            null,
            null,
            false, 
            false,
            '',
            '',
            false
        );
    }


    fnOnGridCellClick(params) {
        switch (params.column.colId) {
            case 'selected':
                this.checkedList = this.gridData.filter(a => a.selected)
                this.hasFormChanges = true;
                break;
          }
      }    
    

    GetBrandList() {
      let request = new ApiRequest<GetAndSaveItemBrandsReqResp>(
        "GetItemBrands",
        environment.applicationVersion,
        environment.requestId
      );
      let requestInfo = new GetAndSaveItemBrandsReqResp();
      requestInfo.action = 4;
      requestInfo.orgId = this.claims.OrgId;
      request.requestInfo = requestInfo;
    
    
      this.vendorService
        .GetItemBrands(request)
        .subscribe((response: IApiresponse<GetAndSaveItemBrandsReqResp>) => {
          if(response){
            this.list = response.responseInfo.itemBrands;    
            this.gridData = this.list; 
            this.gridData.forEach((item) => {
              if (this.selectedIds.includes(item.itemBrandId)) {
                  item.selected = true;
              } else {
                  item.selected = false;
              }
          });
            setTimeout(() => {
              this.gridComponent.refreshGridData();
              this.cdr.detectChanges();
          }, 300); 
          }
        });
    }
    
    fnOnGridCheckAll(isChecked) {
        this.checkedList = this.gridData.filter(a => a.selected)
        this.hasFormChanges = true;
    }    
    fnOnSave(){
        this.outputModel.assignedName = this.checkedList && this.checkedList.length > 0 ? (this.checkedList.length ==1 ? "1 " + this.translate.instant('brands_assigned') : this.checkedList.length + this.translate.instant('brands_assigned')) : null;
        this.outputModel.assignedIdsList = [];
        this.checkedList.forEach((item) => {
        this.outputModel.assignedIdsList.push({itemBrandId: item.itemBrandId});
        });
        this.submitPanelEvent.emit(this.outputModel);
    } 

    alertPanelReceiver(returnValue) {
    if (returnValue) {
      this.closePanelEvent.emit(true);
    }
    else {
      this.alertPanelModel = new AlertPanelModel(
        false,
        "",
        [""],
        "",
        "",
        true,
        this.translate.instant("please_review_or_confirm")
      );
    }
  }
    
}
